import React, { useEffect, useState } from "react";
import { getSucursal } from "../../../../utils/helpers";
import Loader from "../../../general/Loader";

const getPTEstatus = async (key, id) => {
    const response = await fetch(`https://pro.logistics.com.do/api/delivery-planner/checkpoint/${id}`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            "X-Hash-Token": key
        },
    });

    if (!response.ok) return "";

    const json = await response.json();

    return json.data.status;
}

const PlanificadorTareaEstatus = ({id}) => {
    const sucursalInfo = JSON.parse(localStorage.getItem("user"));
    const sucursal = sucursalInfo.sucursales.find((sucursal) => sucursal.id === getSucursal());

    // if(!sucursal.planificador_tareas_key || !sucursal.planificador_tareas_key.valor) return <></>;

    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState("");

    const key = sucursal.planificador_tareas_key?.valor;

    useEffect(() => {
        setLoading(true);

        getPTEstatus(key, id).then((s) => {
            setStatus(s);
            setLoading(false);
        });
    }, []);
    
    const mapper = {
        not_assigned: "No Asignado",
        assigned: "Asignado",
        in_progress: "En Progreso",
        done: "Terminado",
        failed: "No Completado",
        canceled: "Cancelada",
    };

    const color = {
        not_assigned: "#99a1af",
        assigned: "#00a6f4",
        in_progress: "#ff8904",
        done: "#00c951",
        failed: "#fb2c36",
        canceled: "#6a7282",
    };

    return <div className="ml-2 h-100 w-100 d-flex items-center" >
        <strong>Envio:</strong>
            
        {loading ? <Loader type="small" /> : <>
            <div className="ml-2 mr-1 my-auto" style={{height: "1rem", width: "1rem", backgroundColor: color[status], borderRadius: "100%"}}></div>
            <span style={{color: color[status]}}>{mapper[status]}</span>
        </>}
    </div>;
};

export default PlanificadorTareaEstatus;